import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table } from 'antd';
import { Spinner } from '../../../common/index.jsx';
import { trim } from 'lodash';

const StudyPlansTable = ({ filteredSubjects }) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t('Predmet'),
      render: (_, record) => {
        const parts = [record.code, record.name].map((v) =>
          v != null ? v : 0,
        );
        return parts.join(' ');
      },
      width: '35%',
    },
    {
      title: t('Skratka'),
      dataIndex: 'shortcut',
    },
    {
      title: t('Typ povinnosti'),
      dataIndex: 'compulsory_type',
      render: (value) => {
        switch (trim(value)) {
          case '1':
            return t('Povinný');
          case '2':
            return t('Povinne voliteľný');
          case '3':
            return t('Voliteľný');
          default:
            return '';
        }
      },
    },
    {
      title: t('Rozsah'),
      render: (_, record) => {
        const parts = [
          parseInt(record.lecture_hours, 10) || 0,
          parseInt(record.seminar_hours, 10) || 0,
          parseInt(record.lab_hours, 10) || 0,
        ];
        return parts.join('-');
      },
    },
    {
      title: t('Ukončenie'),
      dataIndex: 'completion',
      // render: (value) => {
      //   switch (trim(value)) {
      //     case 'S':
      //       return t('Skúška');
      //     case 'H':
      //       return t('H');
      //     default:
      //       return '';
      //   }
      // },
    },
    {
      title: t('Kredity'),
      dataIndex: 'credits',
      render: (value) => {
        const num = Number(value);
        return isNaN(num) ? '-' : num.toFixed(1);
      },
    },
    {
      title: t('Katedra'),
      dataIndex: 'department_shortcut',
    },
  ];

  return !filteredSubjects ? (
    <Spinner />
  ) : (
    <>
      <Table
        dataSource={filteredSubjects || []}
        columns={columns}
        className="study-plans-table"
        showActionText={false}
        pagination={false}
        rowKey="study_subject_ws_id"
        scroll={{ x: 500 }}
      />
    </>
  );
};

StudyPlansTable.propTypes = {
  filteredSubjects: PropTypes.array,
};

export default StudyPlansTable;
